import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/hooks/useError.tsx";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useCallback, useMemo } from 'react';
import { Button } from '@mui/material';
import { ErrorBar } from "../Components";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function useError(_ref) {
  var resetModels = _ref.resetModels,
      reloadModels = _ref.reloadModels,
      resetSelectedModels = _ref.resetSelectedModels,
      loadedModels = _ref.loadedModels;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      loadModelError = _useState2[0],
      setLoadModelError = _useState2[1];

  var onError = useCallback(function (error) {
    console.error(error);
  }, []);
  var onReloadModelClick = useCallback(function () {
    if (!loadModelError) {
      return;
    }

    reloadModels();
    setLoadModelError(null);
  }, [loadModelError, reloadModels]);
  var onResetModelsClick = useCallback(function () {
    if (!loadModelError) {
      return;
    }

    resetSelectedModels();
    resetModels();
    setLoadModelError(null);
  }, [loadModelError, resetModels, resetSelectedModels]);
  var disabled = Object.values(loadedModels).some(function (status) {
    return status !== 'Finished';
  });
  var ErrorComponent = useMemo(function () {
    return /*#__PURE__*/_jsx(ErrorBar, {
      open: !!loadModelError,
      message: loadModelError === null || loadModelError === void 0 ? void 0 : loadModelError.errorMessage,
      action: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: disabled,
          color: "inherit",
          size: "small",
          onClick: onReloadModelClick,
          children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
        }), /*#__PURE__*/_jsx(Button, {
          color: "inherit",
          size: "small",
          onClick: onResetModelsClick,
          children: "\u0421\u0431\u0440\u043E\u0441"
        })]
      })
    });
  }, [disabled, loadModelError, onReloadModelClick, onResetModelsClick]);
  return useMemo(function () {
    return {
      onError: onError,
      ErrorComponent: ErrorComponent,
      onLoadModelError: setLoadModelError
    };
  }, [ErrorComponent, onError]);
}